import moment from 'moment'

const getFlexDatesExpressDeal = (altDeals, tripType, minRetailPrice) => {
  const filteredDeals = altDeals.filter(eachDeal => {
    eachDeal.isExpressDeal = true
    return eachDeal.fare < minRetailPrice
  }, [])

  if (filteredDeals.length) {
    filteredDeals.sort((priceOne, priceTwo) => {
      return priceOne.fare - priceTwo.fare
    })

    const firstDeal = filteredDeals[0]
    firstDeal.pricingInfo = {
      totalFare: firstDeal.fare,
    }
    firstDeal.isFlexDatesExd = true
    firstDeal.budgetSaver = {
      longCopy:
        'Watching your wallet? Express Deals are your best way to save.',
      shortCopy: 'Express Deals are your best way to save.',
      tag: 'BUDGET FRIENDLY',
    }
    firstDeal.slice = []
    firstDeal.alternateDatesTexts = {
      dateRange: `${moment(firstDeal.departDate).format(
        'ddd, MMM D'
      )} \u2013 ${moment(firstDeal.returnDate).format('ddd, MMM D')}`,
      numberOfDays: `${moment(firstDeal.returnDate).diff(
        moment(firstDeal.departDate),
        'days'
      )} days`,
    }
    firstDeal.slice[0] = {
      originAirportCode: firstDeal.origin1,
      destinationAirportCode: firstDeal.destination1,
    }
    if (tripType === 'RT') {
      firstDeal.slice[1] = {
        originAirportCode: firstDeal.origin2,
        destinationAirportCode: firstDeal.destination2,
      }
    }
    firstDeal.tripType = tripType

    return firstDeal
  }
  return null
}

export { getFlexDatesExpressDeal }
